/*** IMPORTS FROM imports-loader ***/
var define = false;

(function($, window, document, undefined) {
	$(document).ready(function() {
		const $MAIN_CONTENT = $('[data-js-hook="mainContent"]');

		if (!$MAIN_CONTENT.data('offscreen')) {
			const SITE_HEADER_HEIGHT = $('[data-js-hook="header"]').outerHeight();
			const SITE_FOOTER_HEIGHT = $('[data-js-hook="footer"]').outerHeight();

			$MAIN_CONTENT.css({
				'min-height': `calc(100vh - (${ SITE_HEADER_HEIGHT + SITE_FOOTER_HEIGHT }px))`
			});
		}
	});
})(jQuery, window, document);

